import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddGroupMember = () => {
    const {university_name,dean_name,department_name,lab_name,groupId}=useParams()
    const navigate=useNavigate()
    const [users, setUsers] = useState([]); // ✅ initialize as array
    const [selectedUser, setSelectedUser] = useState();
    const [loading, setLoading] = useState(false)
    const [member_role,setMemberRole] = useState("")
    const [member_permission, setMemberPerMission] = useState("")
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await axios.get(
                    `${BASE_URL}/marketplace/university/user-profiles/`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            "x-api-key": process.env.REACT_APP_X_API_KEY,
                        },
                    }
                );

                // ✅ handle paginated OR normal response
                setUsers(res.data.results || res.data || []);
            } catch (error) {
                console.log("Error while getting profiles", error);
                setUsers([]);
            }
        };

        fetchUsers();
    }, []);

    const options = users.map((user) => ({
        value: user.profile_id || user.id,
        label: `${user.name || user.full_name} (${user.email})`
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#f9fafb",
            borderColor: state.isFocused ? "#0f6abf" : "#d1d5db",
            borderRadius: "0.75rem",
            padding: "6px",
            boxShadow: state.isFocused ? "0 0 0 2px rgba(15,106,191,0.2)" : "none",
            "&:hover": {
                borderColor: "#0f6abf"
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e6f0fa"
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#0f6abf",
            fontWeight: "500"
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#0f6abf",
            ":hover": {
                backgroundColor: "#0f6abf",
                color: "white"
            }
        })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!groupId) return alert('group id is required')
        if(!selectedUser) return alert('select user please')
        if(!member_role) return alert('member role required')
        if(!member_permission) return alert('member permission required')
       const formData= new FormData()
       formData.append('user_profile',selectedUser?.value)
       formData.append('group',groupId)
       formData.append('member_role',member_role)
       formData.append('member_permission',member_permission)
       setLoading(true)
       try {
         const response = await axios.post(
                `${BASE_URL}/marketplace/university/labhead/group/member/`,
               formData,
               {
                 headers: {
                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                     "x-api-key": process.env.REACT_APP_X_API_KEY,
                   },
               }
             );
             if(response.status === 201)
             {
                  alert('Lab group member created successfully')
                  navigate( `/marketplace/${university_name}/${dean_name}/${department_name}/${lab_name}/labhead/lab_groups`)
             }
       } catch (error) {
         console.log("error while creating lab group member",error)
       } finally {
        setLoading(false)
       }

    }
    return (
        <div className="max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900">Add Group Member</h1>
                    </div>
                    <p className="text-gray-500 text-sm">
                        Fill in the details below to add a new group with members to your organization.
                    </p>
                </div>
                {/* Form */}
                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* Department Name */}
                    {/* Head of Department */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Select Group Members
                            </label>
                        </div>
                        <div className="relative">
                            <Select
                                options={options}
                                //   isMulti
                                value={selectedUser}
                                onChange={setSelectedUser}
                                placeholder="Select group members"
                                styles={customStyles}
                            />
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Choose the group member who will lead this group
                        </p>
                    </div>
                    {/* Select Custom Permision */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Select Roles
                            </label>
                        </div>
                        <div className="relative">
                            <select
                                required
                                value={member_role || ""}
                                onChange={(e) => setMemberRole(e.target.value)}
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                                style={{
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "right 16px center"
                                }}
                            >
                                <option value="" >Select roles</option>

                                <option value="scientist">Scientist</option>
                                <option value="assistant">Assistant</option>
                                <option value="analyst">Analyst</option>
                                <option value="external">External</option>
                            </select>
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Choose permissions for this user
                        </p>
                    </div>
                    {/* Select Custom Permision */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Select Custom Permissions
                            </label>
                        </div>
                        <div className="relative">
                            <select
                                required
                                value={member_permission || ""}
                                onChange={(e) => setMemberPerMission(e.target.value)}
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                                style={{
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "right 16px center"
                                }}
                            >
                                <option value="" >Select permissions</option>
                                <option value="upload_data">Upload data</option>
                                <option value="view_only">View only</option>
                                <option value="approve_results">Approve results</option>
                                <option value="edit_experiments">Edit experiments</option>
                            </select>
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Choose permissions for this user
                        </p>
                    </div>
                    <button
                        className="mt-4 w-full bg-[#0f6abf] text-white py-3 rounded-xl font-medium hover:bg-[#0a5ca8] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <>
                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                <span>Creating Group...</span>
                            </>
                        ) : (
                            <>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Create New Group Member
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default AddGroupMember
